import useHasPermitForZone from 'hooks/useHasPermitForZone';
import usePermitParkZone from 'hooks/usePermitParkZone';
import useSelectParkingZone from 'hooks/useSelectParkingZone';
import React from 'react';
import { useActiveElementStore } from 'stores/activeElementStore';
import { AimoMarkerProps } from 'types/MapTypes';
import WebMarker from './RNWeb/WebMarker';

const AimoMarker = ({
  markerType,
  id,
  coordinate,
  withLTP = false,
  onPress,
  isEvChargingOnlyZone = false,
  ...rest
}: AimoMarkerProps) => {
  const permitForParkZone = usePermitParkZone(id);
  const hasPermitForZone = useHasPermitForZone(id);
  // Select the comparison, not the uid: one marker is rendered per zone, so
  // subscribing to the raw uid re-renders every marker on any selection change.
  const isActiveElement = useActiveElementStore(
    (state) => state.activeElement === id
  );
  const { handleParkZoneSelected } = useSelectParkingZone();

  const onPressMarker = () => {
    // The chargers in a zone may have only public prices, a mix of public and private prices,
    // or only private prices. At this point, we don't have pricing information available,
    // so we'll navigate directly to charger selection only when we know the user has
    // access to the zone even if it contains only private prices.
    const goDirectlyToChargerSelect = isEvChargingOnlyZone && hasPermitForZone;
    handleParkZoneSelected(
      id,
      coordinate,
      withLTP,
      permitForParkZone?.id,
      false,
      goDirectlyToChargerSelect
    );
  };

  return (
    <WebMarker
      coordinate={coordinate}
      onPress={onPress ?? onPressMarker}
      iconString={markerType || 'default'}
      id={id}
      isActive={isActiveElement}
      {...rest}
    />
  );
};

export default AimoMarker;
